<template>
  <div id="mesa-selecionar-tipo-apolice-modal" class="px-5 py-5 pb-5 text-sm-center">
    <!-- TODO: colocar a setinha pra sair do modal -->
    <h4 class="blue--text headline font-weight-bold mb-1">
      Criar Endosso
    </h4>
    <p class="subheading pb-4 ">
      Primeiro, selecione o tipo de endosso que deseja solicitar: 
    </p>
    <button
      class="button jns-button font-weight-bold mb-4"
      @click="$emit('select', { kind: KIND_ENDORSEMENTS.CANCELAMENTO })"
    >
      Cancelamento
    </button>

    <button
      class="button jns-button font-weight-bold "
      @click="$emit('select', { kind: KIND_ENDORSEMENTS.ALTERACAO })"
    >
      Alteração de Vigência e/ou IS
    </button>
  </div>
</template>

<script type="js">
import { KIND_ENDORSEMENTS } from '@/libs/endorsement'
export default {
  name: "MesaSelecionarTipoApoliceModal",
  
  data() {
    return {
      KIND_ENDORSEMENTS
    };
  },
  methods: { }
};
</script>

<style lang="scss">
#mesa-selecionar-tipo-apolice-modal {
  .jns-button {
    background-color: #282498;
  }
}
</style>



// WEBPACK FOOTER //
// ./src/components/MesaSelecionarTipoApoliceModal.vue